export const PAGES = [
  { path: '/pages/partnerships', label: 'Partnerships' },
  { path: '/pages/start', label: 'Start' },
  { path: '/pages/corporategifting', label: 'Corporate gifting' },
] as const;

export const RANGES = [7, 28, 90] as const;
export const DM_VERSIONS = [
  { label: 'LinkedIn first A', utmContent: '' },
  { label: 'LinkedIn first B', utmContent: '' },
  { label: 'LinkedIn second A', utmContent: '' },
  { label: 'LinkedIn second B', utmContent: '' },
  { label: 'ManyChat A', utmContent: '' },
  { label: 'ManyChat B', utmContent: '' },
] as const;
// Kyu edits this list; empty = no dots.
export const DM_BATCH_DAYS: string[] = [];
export const GA4_PROPERTY_ID = '339794084';
// Fill when Clarity access lands; buttons stay hidden while empty.
export const CLARITY_PROJECT_ID = '';
